import { CatalogAction } from "../actions";
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";
import { notification } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
export default class CatalogMiddleWare {
  static *GetCategories(action) {
    const { params } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(`categories`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getCategoriesSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getCategoriesError());
    }
  }

  static *CatalogProduct(action) {
    const { params, isTrue } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    const qureyParams = new URLSearchParams(params).toString();
    const URL = !isTrue
      ? `rmx_companies/${companyId}/products?${qureyParams}`
      : `/products?${qureyParams}`;
    try {
      let res = yield ApiCaller.Get(URL, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(
          CatalogAction.getProductSuccess(res.data.data, res.data.meta)
        );
      } else {
        yield put(CatalogAction.getProductError());

        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getProductError());
    }
  }

  static *ShipingCost(action) {
    const { params, id } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/shipping_charges/${id}`,
        params,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.updateShipingCostSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.updateShipingCostError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateShipingCostError());
    }
  }

  static *GetShipingCost(action) {
    const { params } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/shipping_charges`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.getShipingCostSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getShipingCostError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getShipingCostError());
    }
  }

  static *PostProduct(action) {
    const { payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    // console.log('payload==>',payload)
    let updatedData = [];
    if (payload) {
      const updatedPayload = payload.map((item) => {
        return {
          basemix_id: item.basemix_id,
          category_id: item.category_id,
          derived_from: item.id,
          product_additive: item.product_additives,
          price: item.price,
          name: item.name,
          sku: item.sku,
          weight: item.weight,
          description: item.description,
        };
      });
      updatedData = updatedPayload;
    }

    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/products`,
        { rmx_product: updatedData },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        cb() && cb();
        yield put(CatalogAction.postProductSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.postProductError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postProductError());
    }
  }

  static *UpdateProduct(action) {
    const { params, id, activestatus, cb } = action;

    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    const URL = activestatus
      ? `rmx_companies/${companyId}/products/${id}/${activestatus}`
      : `rmx_companies/${companyId}/products/${id}`;
    try {
      let res = yield ApiCaller.Put(
        // `rmx_companies/${companyId}/products/${id}`
        URL,
        activestatus
          ? {}
          : {
              price: params.price,
              product_additive: params.rmx_product_additives,
            },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.updateProductSuccess(res.data.data));

        cb() && cb();
        if (activestatus) {
          info("success", "Status Changed Success!");
        } else {
          info("success", "Product detail updated successfully");
        }

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.updateProductError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateProductError());
    }
  }

  static *CustomProduct(action) {
    const { payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    let formData = new FormData();
    payload.product_additive.map((item) => {
      formData.append("product_additive[]", JSON.stringify(item));
    });
    delete payload.product_additive;

    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/custom_product`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        yield put(CatalogAction.postCustomProductSuccess(res.data.data));
        info("success", "Product added successfully!");

        cb() && cb();
      } else {
        yield put(CatalogAction.postCustomProductError());

        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postCustomProductError());
    }
  }

  static *GetBasemixCategories(action) {
    const { params } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Get(`basemix_categories`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getBasemixCategoriesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getBasemixCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getBasemixCategoriesError());
    }
  }

  static *GetBasemixes(action) {
    const { params } = action;

    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/basemixes?per_page=10000`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.getBasemixesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getCategoriesError());
    }
  }

  static *GetAddivites(action) {
    const { params } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/additives?per_page=10000`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.getAdditivesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getAdditivesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getAdditivesError());
    }
  }

  static *GetBasemixesCategories(action) {
    const { params } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Get(`categories?per_page=10000`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getBasemixesCategoriesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getBasemixesCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getBasemixesCategoriesError());
    }
  }

  static *PostBasemix(action) {
    const { payload, urlParams, cb } = action;
    console.log("Heelo==>", urlParams);
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/${urlParams}`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        yield put(CatalogAction.getBasemixesReq());
        yield put(CatalogAction.getAdditivesReq());
        if (urlParams === "basemix") {
          info("success", "Basemix added successfully!");
        }
        if (urlParams === "additive") {
          info("success", "Additive added successfully!");
        }
        cb() && cb();
      } else {
        yield put(CatalogAction.postBasemixError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postBasemixError());
    }
  }

  static *GetTemplateReq(action) {
    const { params } = action;
    console.log("params", params);
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/download_template`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.getTemplateSuccess(res.data.data));
        notification.open({
          description:
            "Your request is received. You will be notified over an Email!",
          className: "custom-class",
          style: {
            width: 400,
            backgroundColor: "#2E7D32",
            color: "#fff",
            height: "50%",
            marginTop: "40px",
          },
          icon: <InfoCircleOutlined style={{ color: "#fff" }} />,
        });
        setTimeout(() => {
          notification.open({
            description: "Your File has beeen Created Successfull!",
            className: "custom-class",
            style: {
              width: 300,
              backgroundColor: "#2E7D32",
              color: "#fff",
              height: "50%",
            },
            icon: <InfoCircleOutlined style={{ color: "#fff" }} />,
          });
        }, 1000);
      } else {
        yield put(CatalogAction.getTemplateError());
        info("error", res.data.error.message);
        notification.open({
          description: "Something Went Wrong",
          className: "custom-class",
          style: {
            width: 300,
            backgroundColor: "red",
            color: "#fff",
          },
          icon: <InfoCircleOutlined style={{ color: "#fff" }} />,
        });
      }
    } catch (err) {
      yield put(CatalogAction.getTemplateError());
    }
  }

  static *PostFile(action) {
    const { payload } = action;

    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/products/upload`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.postFileSuccess(res.data.data));
      } else {
        yield put(CatalogAction.postFileError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postFileError());
    }
  }
}
